/**
 * Priority Navigation -- folds header nav items that don't fit on one line
 * into the existing "More" dropdown, instead of letting them wrap to a
 * second row (stock Dawn's .list-menu--inline { flex-wrap: wrap }).
 *
 * Phase 3 Follow-up subtask 18 (CLAUDE-THEMES.md). Progressive enhancement
 * only -- the server-rendered nav (all items inline, "More" holding its
 * full curated list) is the complete no-JS/SEO/AI-crawler baseline; this
 * script only rearranges already-rendered DOM, it never adds or removes
 * links.
 */
(function () {
  'use strict';

  if (typeof ResizeObserver === 'undefined') return;

  var nav = document.querySelector('.header__inline-menu');
  if (!nav) return;

  var list = nav.querySelector(':scope > ul.list-menu--inline');
  if (!list) return;

  var items = Array.prototype.filter.call(list.children, function (el) {
    return el.tagName === 'LI';
  });
  if (items.length < 2) return;

  // "More" is expected to be the last top-level item and a real dropdown.
  // If a future menu edit breaks that assumption, bail loudly instead of
  // silently folding items into the wrong place.
  var moreItem = items[items.length - 1];
  var moreDetails = moreItem.querySelector('details');
  if (!moreDetails) {
    console.warn('[priority-nav] last header nav item has no dropdown -- expected the curated "More" item here. Skipping.');
    return;
  }
  var moreList = moreDetails.querySelector(':scope > ul.header__submenu');
  if (!moreList) return;

  // Canonical left-to-right order, captured once. Excludes "More" itself.
  var originalItems = items.slice(0, -1);

  var divider = document.createElement('li');
  divider.className = 'priority-nav__divider';
  divider.setAttribute('role', 'separator');

  function labelEl(li) {
    return li.querySelector(':scope > a') ||
           li.querySelector(':scope > header-menu > details > summary');
  }

  // custom_fist_link (component-header-custom.css) gives top-level items
  // their horizontal-row vertical padding; caption-large is what the
  // existing curated "More" links use for their vertical-list sizing.
  // Swapping both is what makes a folded item look native inside "More"
  // instead of like a stray top-level link.
  function foldStyle(li) {
    li.classList.remove('custom_fist_link');
    var label = labelEl(li);
    if (label) label.classList.add('caption-large');
  }

  function restoreStyle(li) {
    li.classList.add('custom_fist_link');
    var label = labelEl(li);
    if (label) label.classList.remove('caption-large');
  }

  function restoreAll() {
    originalItems.forEach(function (li) {
      if (li.parentElement === moreList) {
        restoreStyle(li);
        list.insertBefore(li, moreItem);
      }
    });
    if (divider.parentElement) divider.parentElement.removeChild(divider);
  }

  function measure() {
    if (nav.offsetWidth === 0) return; // hidden below the drawer-menu breakpoint

    // Always restore-then-refold from scratch so the result never depends
    // on which direction the viewport moved since the last pass.
    restoreAll();

    nav.classList.add('priority-nav--measuring');

    for (var i = originalItems.length - 1; i >= 0; i--) {
      if (nav.scrollWidth <= nav.clientWidth) break;
      var li = originalItems[i];
      foldStyle(li);
      if (!divider.parentElement) moreList.insertBefore(divider, moreList.firstChild);
      // Insert right after the divider each time so items end up in their
      // original left-to-right order (most recently folded gets pushed
      // down as earlier items fold in behind it).
      moreList.insertBefore(li, divider.nextSibling);
    }

    nav.classList.remove('priority-nav--measuring');
  }

  var scheduled = false;
  var fontsSettled = false;
  function scheduleMeasure() {
    if (!fontsSettled) return;
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function () {
      scheduled = false;
      measure();
    });
  }

  new ResizeObserver(scheduleMeasure).observe(nav);

  // Phase 3 Follow-up Round 3, subtask 17 correction (CL-156): this used to
  // measure up to twice on a fresh load -- once immediately (ResizeObserver's
  // own guaranteed first callback fires on .observe() even with no real
  // resize, coalescing with the explicit call that used to sit here), using
  // whatever font happened to be active at that instant (fallback, or
  // invisible text mid-block-period under font-display: optional), then
  // again once document.fonts.ready resolved, using the settled font. If the
  // two passes disagreed on which items needed folding, the result was a
  // real, visible flicker -- items fold into "More" on the early guess, then
  // un-fold back out once the real measurement runs, which Zach visually
  // confirmed as a brief "collapse into a narrow bar, then expand" on every
  // page load. Fix: gate every measurement behind fonts.ready via the
  // fontsSettled flag above, so folding only ever happens once, against the
  // final font state -- nothing to walk back. Browsers without the Font
  // Loading API measure immediately, matching the original always-immediate
  // behavior (they have no signal to wait for in the first place).
  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(function () {
      fontsSettled = true;
      scheduleMeasure();
    });
  } else {
    fontsSettled = true;
    scheduleMeasure();
  }
})();
